var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSalesIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_172_359)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.125 9.8V9.1875C20.125 6.44219 15.9906 4.375 10.5 4.375C5.00938 4.375 0.875 6.44219 0.875 9.1875V13.5625C0.875 15.8484 3.74063 17.6641 7.875 18.2109V18.8125C7.875 21.5578 12.0094 23.625 17.5 23.625C22.9906 23.625 27.125 21.5578 27.125 18.8125V14.4375C27.125 12.1734 24.3469 10.3578 20.125 9.8ZM7.875 16.4281V13.8359C8.74549 13.9478 9.62236 14.0026 10.5 14C11.3776 14.0026 12.2545 13.9478 13.125 13.8359V16.4281C12.2566 16.5634 11.3788 16.6293 10.5 16.625C9.62116 16.6293 8.74337 16.5634 7.875 16.4281ZM18.375 12.0203V13.5625C18.375 14.4812 17.0187 15.4656 14.875 16.0672V13.5078C16.2859 13.1687 17.4781 12.6547 18.375 12.0203ZM2.625 13.5625V12.0203C3.52187 12.6547 4.71406 13.1687 6.125 13.5078V16.0672C3.98125 15.4656 2.625 14.4812 2.625 13.5625ZM9.625 18.8125V18.3531L10.5 18.375C10.9302 18.375 11.3458 18.3641 11.7469 18.3422C12.1844 18.4953 12.6438 18.6266 13.125 18.7469V21.3172C10.9812 20.7156 9.625 19.7312 9.625 18.8125ZM14.875 21.6781V19.075C15.7454 19.1892 16.6222 19.2476 17.5 19.25C18.3776 19.2526 19.2545 19.1978 20.125 19.0859V21.6781C18.3848 21.9406 16.6152 21.9406 14.875 21.6781ZM21.875 21.3172V18.7578C23.2859 18.4187 24.4781 17.9047 25.375 17.2703V18.8125C25.375 19.7312 24.0187 20.7156 21.875 21.3172Z",
    fill: "#333333"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_172_359"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalesIcon);
export default __webpack_public_path__ + "static/media/sales Icon.8686fb651b7743369912a04d471ddcfe.svg";
export { ForwardRef as ReactComponent };